module.exports = __webpack_public_path__ + "img/illu_noResult_mycontent.012ae9c9.png";